// French and Arabic texts for the tests module (tests, placement test, editor,
// submissions). The base translations copy the English module and only override
// part of it, so these values are applied on top and DO replace what is there.

const fr = {
  common: {
    backToHome: "Retour à l'accueil",
    select: "Sélectionner",
    choose: "Choisir",
    description: "Description",
    type: "Type",
  },
  testTypes: {
    text_comprehension: "Compréhension de texte",
    grammar: "Grammaire",
    vocabulary: "Vocabulaire",
    math_problems: "Problèmes de mathématiques",
    calculations: "Calculs",
    problem_solving: "Résolution de problèmes",
    data_interpretation: "Interprétation de données",
    written_expression: "Expression écrite",
    mixed_test: "Test mixte",
  },
  dashboard: {
    roleAdmin: "Administrateur",
    stats: {
      tests: "Tests",
      forCurrentFilters: "Pour les filtres actuels",
      published: "Publiés",
      visibleForStudents: "Visibles par les élèves",
      submissions: "Copies",
      totalSubmissions: "Total des copies",
      notReviewed: "Non corrigées",
      needsReview: "À corriger",
    },
    insightsTitle: "Indicateurs",
    insightsSubtitle: "Aperçu rapide des publications, des corrections et de l'activité.",
    publishRate: "Taux de publication",
    publishedVsDrafts: "Publiés / brouillons",
    drafts: "Brouillons",
    reviewLoad: "Corrections en attente",
    topTestsNeedingReview: "Tests les plus en attente de correction",
    nothingToReview: "Rien à corriger pour le moment.",
    testActivity: "Activité des tests",
    newTests14Days: "Nouveaux tests sur les 14 derniers jours",
    needsReviewTitle: "À corriger",
    needsReviewSubtitle: "Tests avec des copies non corrigées.",
    startReview: "Commencer la correction",
    manageTitle: "Tests",
    manageSubtitle: "Gérez les tests et corrigez les copies par niveau.",
    newTest: "Nouveau test",
    filterProgram: "Filtrer par programme",
    filterLevel: "Filtrer par niveau",
    allPrograms: "Tous les programmes",
    allLevels: "Tous les niveaux",
    onlyNotReviewed: "Non corrigés uniquement",
    noTestsFound: "Aucun test trouvé.",
  },
  exerciseTypes: {
    multiple_choice: "Choisir",
    true_false: "Vrai / Faux",
    short_text: "Écrire",
    long_text: "Écrire",
    essay: "Rédaction",
    fill_blanks: "Compléter",
    match_pairs: "Relier",
    connect_arrow: "Relier par flèches",
    select_words: "Sélectionner des mots",
    stimulus: "Lire",
    diagram_label: "Légender un schéma",
    image_label: "Légender une image",
    drag_drop: "Glisser-déposer",
    data_interpretation: "Données",
    task: "Tâche",
  },
  newTest: {
    subtitle: "Créez un test, puis ajoutez-y des exercices.",
    detailsTitle: "Détails du test",
    failedCreate: "Impossible de créer le test",
  },
  take: {
    doNotLeave: "Ne quittez pas la page pendant le test.",
    confirmLeave: "Voulez-vous quitter le test ?",
    confirmUnanswered:
      "Vous n'avez pas répondu à {{n}} question(s). Envoyer vos réponses quand même ?",
    answered: "Répondu :",
    progress: "Progression",
    questionNavigation: "Navigation entre les questions",
    questionLabel: "Question {{num}}",
    submittedTitle: "Envoyé",
    submittedBody: "Vos réponses ont été envoyées à l'enseignant.",
    backToTests: "Retour aux tests",
    test: "Test",
    timeLeft: "Temps restant",
    durationLabel: "Durée",
    minutesShort: "min",
    failedLoad: "Impossible de charger le test",
    failedSubmit: "Impossible d'envoyer le test",
    testNotFound: "Test introuvable.",
    noExercisesYet: "Aucun exercice pour le moment.",
    previewModeNote:
      "Mode aperçu (les enseignants et administrateurs ne peuvent pas envoyer).",
    passage: "Texte",
  },
  placement: {
    title: "Test de niveau",
    chooseLevel: "Choisissez un niveau",
    pickSubtitle: "Nous choisirons le test publié le plus récent pour ce niveau.",
    backHome: "Retour à l'accueil",
    editInfo: "Modifier les informations",
    start: "Commencer",
    failedLoad: "Impossible de charger les tests de niveau",
    noPublished: "Aucun test de niveau publié pour ce programme.",
    noteNoLead:
      "Choisissez un niveau, puis remplissez le formulaire enfant / contact avant de commencer.",
    noteLead: "Enfant : {{child}} — Parent : {{parent}}",
    requireInfoOnlyStudentsParents: "Seuls les élèves et les parents peuvent envoyer.",
    requireInfoFillFirst: "Veuillez d'abord remplir le formulaire d'informations.",
    testNotFound: "Test introuvable",
    tryAnotherLevel: "Essayez un autre niveau.",
    chooseLevelCta: "Choisir le niveau",
    changeProgram: "Changer de programme",
    diagramAlt: "Schéma",
    chooseProgram: "Choisissez un programme",
    noPrograms: "Aucun programme avec un test de niveau publié.",
    pickProgramSubtitle:
      "Sélectionnez un programme pour voir les tests de niveau disponibles.",
    startForm: {
      validationError:
        "Veuillez remplir les informations de l'enfant et au moins un contact (téléphone ou e-mail).",
      title: "Informations sur l'enfant",
      subtitle:
        "Nous enverrons les résultats à l'enseignant pour qu'il puisse vous contacter.",
      childFullName: "Nom complet de l'enfant",
      childGrade: "Classe / niveau",
      parentFullName: "Nom complet du parent",
      parentPhone: "Téléphone",
      parentEmail: "E-mail",
      city: "Ville",
      notes: "Remarques",
      consent:
        "J'accepte d'envoyer mes informations et les résultats du test à l'enseignant pour être recontacté.",
      continue: "Continuer",
      contactHint: "* Obligatoire. Indiquez au moins un téléphone ou un e-mail.",
      errors: {
        child_full_name: "Indiquez le nom de l'enfant.",
        parent_full_name: "Indiquez le nom du parent.",
        contact: "Indiquez un téléphone ou un e-mail.",
        consent: "Cochez la case d'accord pour continuer.",
      },
    },
  },
  runner: {
    matchInstruction: "Sélectionnez un élément à gauche, puis sa correspondance à droite.",
    imageAlt: "Image",
    categorizeAria: "Classer",
    orderInstruction: "Remettez les éléments dans l'ordre.",
    dataAlt: "Données",
    writeLabel: "Écrivez la légende",
    diagramLabelingNote: "Question de légende de schéma.",
    writeAnswer: "Écrivez votre réponse ici...",
    blankLabel: "Trou {{id}}",
    choose: "Choisir",
    true: "Vrai",
    false: "Faux",
    hotspotLabel: "Zone {{id}}",
    imageLabelInstruction:
      "Choisissez une légende puis touchez une zone (ou l'inverse). Pour effacer : sélectionnez une zone et appuyez sur Suppr.",
    moveUp: "Monter",
    moveDown: "Descendre",
    unsupportedType: "Type de question non pris en charge : {{type}}",
  },
  editor: {
    durationMinutes: "Durée (minutes)",
    topic: "Thème",
    prompt: "Consigne",
    text: "Texte",
    rows: "Lignes",
    points: "Points",
    pointsAbbrev: "pts",
    pointsIgnored: "Points (ignorés pour la note automatique)",
    noExercisesYet: "Aucun exercice pour le moment.",
    adding: "Ajout...",
    confirmDeleteExercise: "Supprimer cet exercice ?",
    failedAddExercise: "Impossible d'ajouter l'exercice",
    failedDeleteExercise: "Impossible de supprimer l'exercice",
    failedSaveExercise: "Impossible d'enregistrer l'exercice",
    failedSaveTest: "Impossible d'enregistrer le test",
    gradingTitle: "Notation",
    allowPartialCredit: "Autoriser les points partiels",
    negativePerWrongOptional: "Points négatifs par erreur (facultatif)",
    caseInsensitiveMatching: "Ignorer les majuscules / minuscules",
    presentation: "Présentation",
    presentationList: "Liste",
    presentationUnderline: "Souligné (comme sur papier)",
    qcmMode: "Mode QCM",
    qcmModeSingle: "Choix unique",
    qcmModeMultiple: "Choix multiple",
    allowMultipleAnswers: "Autoriser plusieurs réponses",
    optionTextPlaceholder: "Texte de l'option",
    correctId: "ID correct",
    fillBlanksTemplateLabel: "Modèle",
    blankPlaceholder: "Texte du trou",
    blankAcceptedAnswersComma: "Réponses acceptées (séparées par des virgules)",
    acceptedAnswersOnePerLine: "Réponses acceptées (une par ligne)",
    addBlank: "+ Ajouter un trou",
    removeBlank: "Supprimer le trou",
    mode: "Mode",
    modeOrder: "Ordonner",
    modeCategorize: "Classer",
    order: "Ordre",
    orderAnswerKeyHint: "Définissez l'ordre correct avec les ID ci-dessus.",
    categories: "Catégories",
    categoryLabelPlaceholder: "Nom de la catégorie",
    addCategory: "+ Ajouter une catégorie",
    removeCategory: "Supprimer la catégorie",
    items: "Éléments",
    itemAcceptedAnswersComma: "Réponses acceptées (séparées par des virgules)",
    itemCorrectCategory: "Catégorie correcte",
    addItem: "+ Ajouter un élément",
    removeItem: "Supprimer l'élément",
    labels: "Légendes",
    labelPlaceholder: "Légende",
    labelTextPlaceholder: "Texte de la légende",
    placeholderLabel: "Légende",
    addLabel: "+ Ajouter une légende",
    removeLabel: "Supprimer la légende",
    hotspots: "Zones",
    hotspotsHint: "Ajoutez des zones en cliquant sur l'image.",
    addHotspot: "+ Ajouter une zone",
    removeHotspot: "Supprimer la zone",
    hotspotCorrectLabel: "Légende correcte",
    hotspotBuilderAria: "Éditeur de zones",
    hotspotAlt: "Zone",
    hotspotBuilderTip:
      "Cliquez pour ajouter. Faites glisser pour déplacer / redimensionner. Appuyez sur Suppr pour retirer.",
    resizeHotspotLabel: "Redimensionner la zone {{id}}",
    imageUrl: "URL de l'image",
    imageUrlOptional: "URL de l'image (facultatif)",
    imageAlt: "Image",
    selectWordsHint: "Sélectionnez les mots corrects.",
    selectWordsHighlight: "Surligner",
    selectWordsCircle: "Entourer",
    wordPlaceholder: "Mot",
    addWord: "+ Ajouter un mot",
    removeWord: "Supprimer le mot",
    writtenHint: "Répondez par écrit.",
    comprehensionHint: "Répondez à partir du texte.",
    essayManualHint: "Les rédactions sont corrigées manuellement.",
    longTextManualHint: "Une correction manuelle peut être nécessaire.",
    leftColumn: "Colonne de gauche",
    rightColumn: "Colonne de droite",
    textPlaceholder: "Texte",
    addLeftItem: "+ Ajouter un élément à gauche",
    addRightItem: "+ Ajouter un élément à droite",
    removeLeft: "Supprimer à gauche",
    removeRight: "Supprimer à droite",
    leftCorrectRightId: "ID de droite correct pour la gauche {{id}}",
    matchPresentationSelect: "Choix des ID (simple)",
    matchPresentationArrows: "Flèches (comme sur papier)",
    matchAllowManyToOne:
      "Autoriser plusieurs éléments de gauche à se relier au même élément de droite",
    arrowsModeHint:
      "Le mode « Flèches » permet à l'élève de relier la gauche à la droite en cliquant, et trace les flèches.",
    answerKeyBuilderArrows: "Corrigé (flèches)",
    noVisualEditor:
      "Ce type d'exercice n'a pas encore d'éditeur visuel. Changez le type d'exercice pour continuer.",
  },
  submissions: {
    title: "Copies",
    notAllowed: "Accès non autorisé",
    failedLoad: "Impossible de charger les copies",
    failedSave: "Impossible d'enregistrer la correction",
    saveReview: "Enregistrer la correction",
    testNumber: "Test n°{{id}}",
    empty: "Aucune copie pour le moment.",
    submissionNumber: "Copie n°{{id}}",
    studentId: "ID élève : {{id}}",
    exerciseNumber: "Exercice n°{{id}}",
    noAnswers: "Aucune réponse.",
    points: "Points : {{n}}",
    awardedPoints: "Points attribués (0–{{max}})",
    autoScore: "Auto : {{n}}",
    blank: "Trou {{id}}",
    leadLabel: "Prospect : {{child}} ({{parent}})",
    missingExercise: "Exercice introuvable pour cette réponse.",
    noAnswer: "Pas de réponse",
    noAnswerExpected: "Aucune réponse attendue.",
    noSelection: "Aucune sélection",
    studentLabel: "Élève : {{name}}",
    submittedAt: "Envoyé : {{when}}",
    submittedBy: "Par : {{name}}",
    unknownExercise: "Exercice inconnu",
    unsupportedAnswer:
      "Réponse enregistrée, mais impossible à afficher pour ce type de question.",
  },
};

const ar = {
  testTypes: {
    text_comprehension: "فهم النص",
    grammar: "القواعد",
    vocabulary: "المفردات",
    math_problems: "مسائل رياضية",
    calculations: "العمليات الحسابية",
    problem_solving: "حلّ المشكلات",
    data_interpretation: "تحليل البيانات",
    written_expression: "التعبير الكتابي",
    mixed_test: "اختبار متنوّع",
  },
  dashboard: {
    stats: {
      tests: "الاختبارات",
      forCurrentFilters: "حسب عوامل التصفية الحالية",
      published: "منشورة",
      visibleForStudents: "ظاهرة للتلاميذ",
      submissions: "الإجابات",
      totalSubmissions: "مجموع الإجابات",
      notReviewed: "غير مصحّحة",
      needsReview: "تحتاج تصحيحاً",
    },
    insightsTitle: "مؤشّرات",
    insightsSubtitle: "نظرة سريعة على النشر والتصحيح والنشاط.",
    publishRate: "نسبة النشر",
    publishedVsDrafts: "المنشورة مقابل المسوّدات",
    drafts: "المسوّدات",
    reviewLoad: "التصحيحات المنتظرة",
    topTestsNeedingReview: "أكثر الاختبارات انتظاراً للتصحيح",
    nothingToReview: "لا شيء للتصحيح حالياً.",
    testActivity: "نشاط الاختبارات",
    newTests14Days: "اختبارات جديدة خلال آخر 14 يوماً",
    needsReviewTitle: "تحتاج تصحيحاً",
    needsReviewSubtitle: "اختبارات بها إجابات غير مصحّحة.",
    startReview: "ابدأ التصحيح",
    manageTitle: "الاختبارات",
    manageSubtitle: "أدِر الاختبارات وصحّح الإجابات حسب المستوى.",
    newTest: "اختبار جديد",
    filterProgram: "تصفية حسب البرنامج",
    filterLevel: "تصفية حسب المستوى",
    allPrograms: "كلّ البرامج",
    allLevels: "كلّ المستويات",
    onlyNotReviewed: "غير المصحّحة فقط",
    noTestsFound: "لم يتمّ العثور على اختبارات.",
  },
  exerciseTypes: {
    multiple_choice: "اختر",
    true_false: "صحيح / خطأ",
    short_text: "اكتب",
    long_text: "اكتب",
    essay: "إنشاء",
    fill_blanks: "املأ الفراغات",
    match_pairs: "اربط",
    connect_arrow: "اربط بالأسهم",
    select_words: "اختر الكلمات",
    stimulus: "اقرأ",
    diagram_label: "ضع البيانات على الرسم",
    image_label: "ضع البيانات على الصورة",
    drag_drop: "اسحب وأفلت",
    data_interpretation: "بيانات",
    task: "مهمّة",
  },
  newTest: {
    subtitle: "أنشئ اختباراً جديداً ثمّ أضف إليه التمارين.",
    detailsTitle: "تفاصيل الاختبار",
    failedCreate: "تعذّر إنشاء الاختبار",
  },
  take: {
    answered: "تمّت الإجابة:",
    questionLabel: "السؤال {{num}}",
    confirmUnanswered: "لم تُجب عن {{n}} سؤال. هل تريد إرسال إجاباتك رغم ذلك؟",
    test: "اختبار",
    durationLabel: "المدّة",
    minutesShort: "د",
    noExercisesYet: "لا توجد تمارين بعد.",
    previewModeNote: "وضع المعاينة (لا يمكن للمعلّمين والمشرفين الإرسال).",
    passage: "النص",
  },
  placement: {
    backHome: "العودة إلى الرئيسية",
    noteNoLead: "اختر مستوى، ثمّ املأ استمارة الطفل وبيانات الاتصال قبل بدء الاختبار.",
    noteLead: "الطفل: {{child}} — الوليّ: {{parent}}",
    requireInfoOnlyStudentsParents: "يمكن للتلاميذ والأولياء فقط الإرسال.",
    requireInfoFillFirst: "يرجى ملء استمارة المعلومات أوّلاً.",
    testNotFound: "الاختبار غير موجود",
    tryAnotherLevel: "جرّب اختيار مستوى آخر.",
    chooseLevelCta: "اختر المستوى",
    changeProgram: "تغيير البرنامج",
    diagramAlt: "رسم توضيحي",
    chooseProgram: "اختر برنامجاً",
    noPrograms: "لا توجد برامج بها اختبارات تحديد مستوى منشورة.",
    pickProgramSubtitle: "اختر برنامجاً لعرض اختبارات تحديد المستوى المتاحة.",
    startForm: {
      validationError:
        "يرجى ملء معلومات الطفل ووسيلة اتصال واحدة على الأقل (الهاتف أو البريد الإلكتروني).",
      title: "معلومات الطفل",
      subtitle: "سنرسل النتائج إلى المعلّم ليتمكّن من التواصل معك.",
      childFullName: "الاسم الكامل للطفل",
      childGrade: "القسم / المستوى",
      parentFullName: "الاسم الكامل للوليّ",
      parentPhone: "الهاتف",
      parentEmail: "البريد الإلكتروني",
      city: "المدينة",
      notes: "ملاحظات",
      consent: "أوافق على إرسال معلوماتي ونتائج الاختبار إلى المعلّم للتواصل معي.",
      continue: "متابعة",
      contactHint: "* إجباري. أدخل رقم هاتف أو بريداً إلكترونياً على الأقلّ.",
      errors: {
        child_full_name: "أدخل اسم الطفل.",
        parent_full_name: "أدخل اسم الوليّ.",
        contact: "أدخل رقم هاتف أو بريداً إلكترونياً.",
        consent: "ضع علامة الموافقة للمتابعة.",
      },
    },
  },
  runner: {
    matchInstruction: "اختر عنصراً من اليسار ثمّ ما يقابله في اليمين.",
    imageAlt: "صورة",
    categorizeAria: "صنّف",
    orderInstruction: "رتّب العناصر.",
    dataAlt: "بيانات",
    writeLabel: "اكتب البيان",
    diagramLabelingNote: "سؤال وضع البيانات على الرسم.",
    writeAnswer: "اكتب إجابتك هنا...",
    blankLabel: "فراغ {{id}}",
    choose: "اختر",
    true: "صحيح",
    false: "خطأ",
    hotspotLabel: "منطقة {{id}}",
    imageLabelInstruction:
      "اختر بياناً ثمّ اضغط على منطقة (أو العكس). للمسح: حدّد منطقة واضغط Delete.",
    moveUp: "إلى الأعلى",
    moveDown: "إلى الأسفل",
    unsupportedType: "نوع سؤال غير مدعوم: {{type}}",
  },
  editor: {
    prompt: "التعليمة",
    pointsIgnored: "النقاط (لا تُحتسب في التصحيح الآلي)",
    negativePerWrongOptional: "خصم عن كلّ خطأ (اختياري)",
    caseInsensitiveMatching: "تجاهل الأحرف الكبيرة والصغيرة",
    presentation: "طريقة العرض",
    presentationList: "قائمة",
    presentationUnderline: "تسطير (كما على الورق)",
    optionTextPlaceholder: "نصّ الخيار",
    correctId: "المعرّف الصحيح",
    fillBlanksTemplateLabel: "النموذج",
    blankPlaceholder: "نصّ الفراغ",
    blankAcceptedAnswersComma: "الإجابات المقبولة (مفصولة بفواصل)",
    acceptedAnswersOnePerLine: "الإجابات المقبولة (إجابة في كلّ سطر)",
    mode: "النمط",
    modeOrder: "ترتيب",
    modeCategorize: "تصنيف",
    order: "الترتيب",
    orderAnswerKeyHint: "حدّد الترتيب الصحيح باستعمال المعرّفات أعلاه.",
    categories: "الأصناف",
    categoryLabelPlaceholder: "اسم الصنف",
    items: "العناصر",
    itemAcceptedAnswersComma: "الإجابات المقبولة (مفصولة بفواصل)",
    itemCorrectCategory: "الصنف الصحيح",
    labels: "البيانات",
    labelPlaceholder: "بيان",
    labelTextPlaceholder: "نصّ البيان",
    placeholderLabel: "بيان",
    hotspotCorrectLabel: "البيان الصحيح",
    hotspotBuilderAria: "محرّر المناطق",
    hotspotAlt: "منطقة",
    hotspotBuilderTip: "انقر للإضافة. اسحب للتحريك أو تغيير الحجم. اضغط Delete للحذف.",
    resizeHotspotLabel: "تغيير حجم المنطقة {{id}}",
    imageUrl: "رابط الصورة",
    imageUrlOptional: "رابط الصورة (اختياري)",
    imageAlt: "صورة",
    selectWordsHint: "اختر الكلمات الصحيحة.",
    selectWordsHighlight: "تظليل",
    selectWordsCircle: "إحاطة بدائرة",
    wordPlaceholder: "كلمة",
    addWord: "+ إضافة كلمة",
    removeWord: "حذف الكلمة",
    writtenHint: "أجب كتابياً.",
    comprehensionHint: "أجب اعتماداً على النص.",
    essayManualHint: "يُصحَّح الإنشاء يدوياً.",
    longTextManualHint: "قد يلزم تصحيح يدوي.",
    leftColumn: "العمود الأيسر",
    rightColumn: "العمود الأيمن",
    textPlaceholder: "نص",
    addLeftItem: "+ إضافة عنصر في اليسار",
    addRightItem: "+ إضافة عنصر في اليمين",
    removeLeft: "حذف من اليسار",
    removeRight: "حذف من اليمين",
    leftCorrectRightId: "المعرّف الصحيح في اليمين للعنصر الأيسر {{id}}",
    matchPresentationSelect: "اختيار المعرّفات (بسيط)",
    matchPresentationArrows: "أسهم (كما على الورق)",
    matchAllowManyToOne: "السماح بربط عدّة عناصر يسرى بنفس العنصر الأيمن",
    arrowsModeHint: "نمط «الأسهم» يسمح للتلميذ بربط اليسار باليمين بالنقر، ويرسم الأسهم.",
    answerKeyBuilderArrows: "مفتاح الإجابة (أسهم)",
  },
  submissions: {
    title: "الإجابات",
    notAllowed: "غير مسموح",
    failedLoad: "تعذّر تحميل الإجابات",
    failedSave: "تعذّر حفظ التصحيح",
    saveReview: "حفظ التصحيح",
    testNumber: "الاختبار رقم {{id}}",
    empty: "لا توجد إجابات بعد.",
    submissionNumber: "الإجابة رقم {{id}}",
    studentId: "معرّف التلميذ: {{id}}",
    exerciseNumber: "التمرين رقم {{id}}",
    noAnswers: "لا توجد إجابات.",
    points: "النقاط: {{n}}",
    awardedPoints: "النقاط الممنوحة (0–{{max}})",
    autoScore: "آلي: {{n}}",
    blank: "فراغ {{id}}",
    leadLabel: "مهتمّ: {{child}} ({{parent}})",
    missingExercise: "لم يُعثر على التمرين الخاص بهذه الإجابة.",
    noAnswer: "لا توجد إجابة",
    noAnswerExpected: "لا يُنتظر أيّ جواب.",
    noSelection: "لم يتمّ الاختيار",
    studentLabel: "التلميذ: {{name}}",
    submittedAt: "أُرسل: {{when}}",
    submittedBy: "بواسطة: {{name}}",
    unknownExercise: "تمرين غير معروف",
    unsupportedAnswer: "تمّ حفظ الإجابة لكن لا يمكن عرضها لهذا النوع من الأسئلة.",
  },
};

// Labels of the simplified test editor (question types, autosave, publishing).
const editorEn = {
  advancedOptions: "Advanced options",
  mcqHint: "Write the choices and tick the correct answer.",
  mcqHintMultiple: "Write the choices and tick every correct answer.",
  markCorrect: "Correct answer",
  correctTag: "Correct",
  removeOption: "Remove option",
  addOption: "+ Add a choice",
  blankSentenceLabel: "Sentence",
  blankSentencePlaceholder: "I [go] to school every [morning|day].",
  blankSentenceHint:
    "Put each word to find between [brackets]. Several accepted answers: [go|walk].",
  blankCount: "{{n}} blank(s) found.",
  pairsHint: "Write each pair on one line. Students will see the right column shuffled.",
  pairLeft: "Item",
  pairRight: "Its match",
  removePair: "Remove pair",
  addPair: "+ Add a pair",
  acceptedHint: "Write the expected answer. Add other spellings you also accept.",
  acceptedPlaceholder: "Accepted answer",
  removeAnswer: "Remove answer",
  addAnswer: "+ Add another accepted answer",
  statusPublished: "Published — students can take it",
  statusDraft: "Draft — students can't see it yet",
  publish: "Publish",
  unpublish: "Unpublish",
  problemsTitle: "Fix these before publishing:",
  questionN: "Question {{n}}",
  keepEditing: "Keep editing",
  publishAnyway: "Publish anyway",
  saveError: "Some changes were not saved",
  allSaved: "All changes saved",
  notSaved: "Not saved",
  chooseType: "1. Choose the type of question",
  moreTypes: "More types",
  fewerTypes: "Fewer types",
  addQuestion: "Add the question",
  stimulusPromptLabel: "2. Paste the text students will read",
  questionPromptLabel: "2. Write the question",
  stimulusText: "Text",
  questionText: "Question",
  questionsTitle: "Questions",
  pointsAbbrev: "pts",
  problems: {
    missingPrompt: "The question is empty.",
    fewOptions: "Add at least two choices.",
    emptyOption: "A choice is empty.",
    noAnswer: "The correct answer is not set.",
    fewPairs: "Add at least two pairs.",
    noQuestions: "The test has no questions yet.",
  },
  typeNames: {
    multiple_choice: "Multiple choice",
    true_false: "True or false",
    short_text: "Short answer",
    fill_blanks: "Fill in the blanks",
    match_pairs: "Matching",
    stimulus: "Text to read",
    long_text: "Written answer",
    connect_arrow: "Connect with arrows",
    select_words: "Pick words",
    essay: "Essay",
    task: "Oral or practical task",
    diagram_label: "Label a diagram",
    image_label: "Label an image",
    drag_drop: "Put in order / sort",
    data_interpretation: "Read data",
  },
  typeHints: {
    multiple_choice: "Choose among answers",
    true_false: "One statement, true or false",
    short_text: "A word or a number",
    fill_blanks: "Missing words in a sentence",
    match_pairs: "Link items two by two",
    stimulus: "A passage before the questions",
    long_text: "A few lines, graded by you",
    connect_arrow: "Link items by drawing arrows",
    select_words: "Circle the right words",
    essay: "Long text, graded by you",
    task: "Done in class, graded by you",
    diagram_label: "Name the parts of a picture",
    image_label: "Place labels on an image",
    drag_drop: "Order or sort items",
    data_interpretation: "Questions about a table",
  },
};

const editorFr = {
  advancedOptions: "Options avancées",
  mcqHint: "Écrivez les choix et cochez la bonne réponse.",
  mcqHintMultiple: "Écrivez les choix et cochez toutes les bonnes réponses.",
  markCorrect: "Bonne réponse",
  correctTag: "Bonne réponse",
  removeOption: "Supprimer le choix",
  addOption: "+ Ajouter un choix",
  blankSentenceLabel: "Phrase",
  blankSentencePlaceholder: "Je [vais] à l'école tous les [matins|jours].",
  blankSentenceHint:
    "Mettez chaque mot à trouver entre [crochets]. Plusieurs réponses acceptées : [vais|va].",
  blankCount: "{{n}} trou(s) trouvé(s).",
  pairsHint:
    "Écrivez chaque paire sur une ligne. Les élèves verront la colonne de droite mélangée.",
  pairLeft: "Élément",
  pairRight: "Sa correspondance",
  removePair: "Supprimer la paire",
  addPair: "+ Ajouter une paire",
  acceptedHint:
    "Écrivez la réponse attendue. Ajoutez les autres écritures que vous acceptez.",
  acceptedPlaceholder: "Réponse acceptée",
  removeAnswer: "Supprimer la réponse",
  addAnswer: "+ Ajouter une autre réponse acceptée",
  statusPublished: "Publié — les élèves peuvent le passer",
  statusDraft: "Brouillon — les élèves ne le voient pas encore",
  publish: "Publier",
  unpublish: "Dépublier",
  problemsTitle: "À corriger avant de publier :",
  questionN: "Question {{n}}",
  keepEditing: "Continuer la modification",
  publishAnyway: "Publier quand même",
  saveError: "Certaines modifications n'ont pas été enregistrées",
  allSaved: "Toutes les modifications sont enregistrées",
  notSaved: "Non enregistré",
  chooseType: "1. Choisissez le type de question",
  moreTypes: "Plus de types",
  fewerTypes: "Moins de types",
  addQuestion: "Ajouter la question",
  stimulusPromptLabel: "2. Collez le texte que les élèves vont lire",
  questionPromptLabel: "2. Écrivez la question",
  stimulusText: "Texte",
  questionText: "Question",
  questionsTitle: "Questions",
  pointsAbbrev: "pts",
  problems: {
    missingPrompt: "La question est vide.",
    fewOptions: "Ajoutez au moins deux choix.",
    emptyOption: "Un choix est vide.",
    noAnswer: "La bonne réponse n'est pas indiquée.",
    fewPairs: "Ajoutez au moins deux paires.",
    noQuestions: "Le test n'a pas encore de questions.",
  },
  typeNames: {
    multiple_choice: "Choix multiple",
    true_false: "Vrai ou faux",
    short_text: "Réponse courte",
    fill_blanks: "Texte à trous",
    match_pairs: "Relier",
    stimulus: "Texte à lire",
    long_text: "Réponse rédigée",
    connect_arrow: "Relier par flèches",
    select_words: "Choisir des mots",
    essay: "Rédaction",
    task: "Tâche orale ou pratique",
    diagram_label: "Légender un schéma",
    image_label: "Légender une image",
    drag_drop: "Ordonner / classer",
    data_interpretation: "Lire des données",
  },
  typeHints: {
    multiple_choice: "Choisir parmi des réponses",
    true_false: "Une affirmation, vraie ou fausse",
    short_text: "Un mot ou un nombre",
    fill_blanks: "Des mots manquants dans une phrase",
    match_pairs: "Associer deux à deux",
    stimulus: "Un texte avant les questions",
    long_text: "Quelques lignes, corrigées par vous",
    connect_arrow: "Associer en traçant des flèches",
    select_words: "Entourer les bons mots",
    essay: "Texte long, corrigé par vous",
    task: "Fait en classe, corrigé par vous",
    diagram_label: "Nommer les parties d'une image",
    image_label: "Placer des étiquettes sur une image",
    drag_drop: "Ordonner ou classer des éléments",
    data_interpretation: "Questions sur un tableau",
  },
};

const editorAr = {
  advancedOptions: "خيارات متقدّمة",
  mcqHint: "اكتب الاختيارات وحدّد الإجابة الصحيحة.",
  mcqHintMultiple: "اكتب الاختيارات وحدّد كلّ الإجابات الصحيحة.",
  markCorrect: "الإجابة الصحيحة",
  correctTag: "صحيحة",
  removeOption: "حذف الاختيار",
  addOption: "+ إضافة اختيار",
  blankSentenceLabel: "الجملة",
  blankSentencePlaceholder: "أذهبُ إلى [المدرسة] كلّ [صباح|يوم].",
  blankSentenceHint:
    "ضع كلّ كلمة مطلوبة بين [معقوفين]. لعدّة إجابات مقبولة: [صباح|يوم].",
  blankCount: "عدد الفراغات: {{n}}.",
  pairsHint: "اكتب كلّ زوج في سطر واحد. سيرى التلاميذ العمود الأيمن مخلوطاً.",
  pairLeft: "العنصر",
  pairRight: "ما يقابله",
  removePair: "حذف الزوج",
  addPair: "+ إضافة زوج",
  acceptedHint: "اكتب الإجابة المنتظرة، وأضف الصيغ الأخرى التي تقبلها.",
  acceptedPlaceholder: "إجابة مقبولة",
  removeAnswer: "حذف الإجابة",
  addAnswer: "+ إضافة إجابة مقبولة أخرى",
  statusPublished: "منشور — يمكن للتلاميذ اجتيازه",
  statusDraft: "مسودّة — لا يراه التلاميذ بعد",
  publish: "نشر",
  unpublish: "إلغاء النشر",
  problemsTitle: "يجب إصلاح ما يلي قبل النشر:",
  questionN: "السؤال {{n}}",
  keepEditing: "مواصلة التعديل",
  publishAnyway: "النشر رغم ذلك",
  saveError: "لم يتمّ حفظ بعض التعديلات",
  allSaved: "تمّ حفظ كلّ التعديلات",
  notSaved: "غير محفوظ",
  chooseType: "1. اختر نوع السؤال",
  moreTypes: "أنواع أخرى",
  fewerTypes: "أنواع أقلّ",
  addQuestion: "إضافة السؤال",
  stimulusPromptLabel: "2. ألصق النصّ الذي سيقرؤه التلاميذ",
  questionPromptLabel: "2. اكتب السؤال",
  stimulusText: "النص",
  questionText: "السؤال",
  questionsTitle: "الأسئلة",
  pointsAbbrev: "نقاط",
  problems: {
    missingPrompt: "السؤال فارغ.",
    fewOptions: "أضف اختيارين على الأقلّ.",
    emptyOption: "أحد الاختيارات فارغ.",
    noAnswer: "لم يتمّ تحديد الإجابة الصحيحة.",
    fewPairs: "أضف زوجين على الأقلّ.",
    noQuestions: "لا يحتوي الاختبار على أسئلة بعد.",
  },
  typeNames: {
    multiple_choice: "اختيار من متعدّد",
    true_false: "صحيح أم خطأ",
    short_text: "إجابة قصيرة",
    fill_blanks: "ملء الفراغات",
    match_pairs: "الربط",
    stimulus: "نصّ للقراءة",
    long_text: "إجابة كتابية",
    connect_arrow: "الربط بالأسهم",
    select_words: "اختيار كلمات",
    essay: "إنشاء",
    task: "مهمّة شفوية أو تطبيقية",
    diagram_label: "تسمية أجزاء رسم",
    image_label: "وضع بيانات على صورة",
    drag_drop: "ترتيب / تصنيف",
    data_interpretation: "قراءة بيانات",
  },
  typeHints: {
    multiple_choice: "اختيار بين إجابات",
    true_false: "عبارة صحيحة أو خاطئة",
    short_text: "كلمة أو عدد",
    fill_blanks: "كلمات ناقصة في جملة",
    match_pairs: "ربط عنصرين ببعضهما",
    stimulus: "نصّ قبل الأسئلة",
    long_text: "بضعة أسطر تصحّحها أنت",
    connect_arrow: "ربط العناصر برسم أسهم",
    select_words: "إحاطة الكلمات الصحيحة",
    essay: "نصّ طويل تصحّحه أنت",
    task: "يُنجز في القسم وتصحّحه أنت",
    diagram_label: "تسمية أجزاء صورة",
    image_label: "وضع بيانات على صورة",
    drag_drop: "ترتيب أو تصنيف عناصر",
    data_interpretation: "أسئلة حول جدول",
  },
};

// Review page: status, per-question verdict, score out of 20.
const placementEn = {
  startForm: {
    contactHint: "* Required. Give at least a phone number or an email.",
    errors: {
      child_full_name: "Enter the child's name.",
      parent_full_name: "Enter the parent's name.",
      contact: "Enter a phone number or an email.",
      consent: "Tick the consent box to continue.",
    },
  },
};
const dashboardEn = {
  noProgramsAssigned:
    "No program is assigned to you yet. Ask an administrator to assign you a program (Admin > Programs) to create tests.",
};
const dashboardFr = {
  placeholderLevel: "ex. CP, 6ème ou Débutant",
  noProgramsAssigned:
    "Aucun programme ne vous est encore attribué. Demandez à un administrateur de vous en attribuer un (Admin > Programmes) pour créer des tests.",
};
const dashboardAr = {
  placeholderLevel: "مثال: السنة الأولى أو مبتدئ",
  noProgramsAssigned:
    "لم يُسند إليك أيّ برنامج بعد. اطلب من أحد المشرفين أن يُسند إليك برنامجاً (الإدارة > البرامج) لإنشاء اختبارات.",
};

const reviewEn = {
  status: { submitted: "To review", reviewed: "Reviewed" },
  verdict: { correct: "Correct", partial: "Partly correct", wrong: "Wrong", toGrade: "To grade", noAnswer: "No answer" },
  showAnswers: "Answers",
  outOf20: "{{n}} / 20",
  gradeByHand: "To grade by hand",
};
const reviewFr = {
  status: { submitted: "À corriger", reviewed: "Corrigé" },
  verdict: { correct: "Juste", partial: "En partie juste", wrong: "Faux", toGrade: "À corriger", noAnswer: "Sans réponse" },
  showAnswers: "Réponses",
  outOf20: "{{n}} / 20",
  gradeByHand: "À corriger à la main",
};
const reviewAr = {
  status: { submitted: "في انتظار التصحيح", reviewed: "مصحّح" },
  verdict: { correct: "صحيح", partial: "صحيح جزئياً", wrong: "خطأ", toGrade: "للتصحيح", noAnswer: "بدون إجابة" },
  showAnswers: "الإجابات",
  outOf20: "{{n}} / 20",
  gradeByHand: "يُصحَّح يدوياً",
};

fr.editor = { ...fr.editor, ...editorFr };
ar.editor = { ...ar.editor, ...editorAr };
fr.submissions = { ...fr.submissions, ...reviewFr };
fr.dashboard = { ...fr.dashboard, ...dashboardFr };
ar.dashboard = { ...ar.dashboard, ...dashboardAr };
ar.submissions = { ...ar.submissions, ...reviewAr };

const testsModuleTranslations = {
  en: {
    testsModule: {
      editor: editorEn,
      submissions: reviewEn,
      dashboard: dashboardEn,
      placement: placementEn,
    },
  },
  fr: { testsModule: fr },
  ar: { testsModule: ar },
};

export default testsModuleTranslations;
